import { MutationOptions, useMutation } from "react-query";
import { API_URL_V3 } from "../api";
import { APIError, APIResponse, post } from "../api";

interface InitiatePayload {
  name: string;
  email: string;
  ref: string;
  redirect_url: string;
}

interface InitiateResponse {
  mono_url: string;
  customer: string;
  meta: {
    ref: string;
  };
  scope: string;
  institution: Array<any>;
  redirect_url: string;
  is_multi: boolean;
  created_at: string;
}

export function useInitiateMonoLink(
  options?: MutationOptions<
    APIResponse<InitiateResponse>,
    APIError,
    InitiatePayload
  >
) {
  const {
    isLoading: initiatingMonoLink,
    isError: isMonoLinkError,
    error: monoLinkError,
    mutate: initiateMonoLink,
  } = useMutation<APIResponse<InitiateResponse>, APIError, InitiatePayload>(
    (variables) => {
      return post(API_URL_V3 + "/mono/initiate-linking", variables, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
    },
    options
  );

  return {
    initiateMonoLink,
    isMonoLinkError,
    monoLinkError,
    initiatingMonoLink,
  };
}

export default useInitiateMonoLink;
